/** Small pieces every receipts screen shows the same way. */

import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";
import { formatCalendarDate } from "@/lib/dates";
import { formatMoney, type Money } from "@/lib/money";
import type { ReceiptStatus } from "./status";

const badgeTones: Record<ReceiptStatus, string> = {
  uploaded: "bg-stone-100 text-stone-700",
  extracting: "bg-amber-50 text-amber-800",
  needs_review: "bg-brand-50 text-brand-800",
  confirmed: "bg-stone-100 text-stone-700",
  extraction_failed: "bg-red-50 text-red-800",
};

export function StatusBadge({ status }: { status: ReceiptStatus }) {
  const { t } = useTranslation();
  return (
    <span className={cn("rounded-full px-2 py-0.5 text-xs font-medium", badgeTones[status])}>
      {t(`receipts.status.${status}`)}
    </span>
  );
}

/** An amount, or a dash when the receipt did not say. Never "$0.00" for "unknown". */
export function Amount({ money, className }: { money: Money | null; className?: string }) {
  return <span className={cn("tabular-nums", className)}>{money ? formatMoney(money) : "—"}</span>;
}

export function PurchaseDate({ date }: { date: string | null }) {
  const { t } = useTranslation();
  return <>{date ? formatCalendarDate(date) : t("receipts.noDate")}</>;
}

export function StoreName({ name }: { name: string }) {
  const { t } = useTranslation();
  return <>{name || t("receipts.unknownStore")}</>;
}
